export const sentences = [
"FREE Newslaundry Tote bag and Sabki Dhulai soap set",
"FREE Sabki Dhulai soap set",
"Access to paywall stories",
"Access to NL Chatbox",
// "Access to our subscriber-only Discord server",
"Access to subscriber-only events, including The Media Rumble and NL Recess",
"Access to podcast RSS links to listen to our paywall podcasts in apps like Apple and Google Podcasts",
"Access to NL Baithak",
]